import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Contactgegevens", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Contacturen", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Contactformulier", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Heeft u vragen of opmerkingen? Middels het contactformulier kunt u vrijblijvend een bericht versturen. MaatOntwikkeling helpt u graag verder! ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Bedankt voor uw bericht. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" MaatOntwikkeling neemt zo spoedig mogelijk contact met u op. Normaliter kunt u een reactie binnen 24 uur verwachten. ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" MaatOntwikkeling, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" computers op maat. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_notice_alert = _resolveComponent("notice-alert")!
  const _component_single_block = _resolveComponent("single-block")!
  const _component_contact_details_table = _resolveComponent("contact-details-table")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_opening_hours_table = _resolveComponent("opening-hours-table")!
  const _component_contact_form = _resolveComponent("contact-form")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Contact",
      displaySearchForm: false
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_notice_alert, null, {
              default: _withCtx(() => [
                _createTextVNode(" Bezoek op locatie is enkel mogelijk middels een afspraak. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_contact_details_table)
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_opening_hours_table)
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createElementVNode("img", { src: $data.contactImage }, null, 8, _hoisted_5)
          ]),
          _: 1
        }),
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_contact_form, null, {
              draft: _withCtx(() => [
                _hoisted_7
              ]),
              sent: _withCtx(() => [
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout, {
      displayOpeningHours: false,
      displayContactDetails: false
    })
  ], 64))
}